import type { Translations } from "../types";

const fa: Translations = {
  "meta.title": "نقشه کلیک‌ها بر اساس کشور",
  "meta.description":
    "نقشه تعاملی جهان: کلیک‌های رایگان برای هر کشور به‌علاوه حمایت مالی از طریق Stripe، PayPal و Buy Me a Coffee.",

  "app.title": "نقشه کلیک‌ها بر اساس کشور",

  "map.intro":
    "روی یک کشور در نقشه کلیک کنید تا یک رأی رایگان به آن بدهید، یا از آن حمایت مالی کنید - هر دو در جدول امتیازات ترکیبی زیر محاسبه می‌شوند. این نقشه فقط حمایت انجام‌شده در این برنامه را نشان می‌دهد، نه ثروت ملی یا تولید ناخالص داخلی واقعی.",
  "map.verifying": "در حال تأیید …",
  "map.confirmNotRobot": "پیش از افزودن کلیک رایگان، لطفاً به‌سرعت تأیید کنید که ربات نیستید:",
  "map.tryAgain": "تلاش مجدد",
  "map.registeringClick": "در حال ثبت کلیک …",
  "map.selectedCountry": "کشور انتخاب‌شده: {name}.",
  "map.selectFirstFeedback": "کشور انتخاب شد. برای افزودن کلیک رایگان، ابتدا در پایین تأیید کنید که ربات نیستید.",
  "map.verificationExpired": "تأیید منقضی شد - دوباره تأیید کنید که ربات نیستید.",
  "map.slowDown": "کمی آهسته‌تر - پیش از کلیک بعدی کمی صبر کنید.",
  "map.clickFailed": "ثبت کلیک ممکن نشد. لطفاً دوباره تلاش کنید.",
  "map.clickErrorGeneric": "خطا در ثبت کلیک.",
  "map.leaderboardHeading": "جدول امتیازات کشورها",
  "map.emptySelection": "برای کلیک یا حمایت، یک کشور را در نقشه انتخاب کنید.",
  "map.loadingData": "در حال بارگذاری داده‌ها …",

  "worldmap.loadError": "بارگذاری نقشه ممکن نشد.",
  "worldmap.resetZoom": "بازنشانی بزرگ‌نمایی",
  "worldmap.resetButton": "⤾ بازنشانی",
  "worldmap.loadingMap": "در حال بارگذاری نقشه …",
  "worldmap.unknownCountry": "نامشخص",
  "worldmap.ariaClicks": "{name}: {clicks} کلیک",
  "worldmap.tooltipClicks": "{clicks} کلیک",

  "legend.fewer": "کلیک کمتر",
  "legend.more": "کلیک بیشتر",

  "list.empty": "هنوز کلیکی ثبت نشده است. اولین نفر باشید!",
  "list.ariaLabel": "جدول امتیازات کشورها بر اساس تعداد کلیک",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY تنظیم نشده است - برای پیکربندی به README مراجعه کنید.",
  "human.verificationFailedGeneric": "تأیید ناموفق بود.",
  "human.networkError":
    "اتصال به سرویس تأیید ممکن نشد (خطای شبکه) - VITE_SUPABASE_URL، استقرار verify-human و ALLOWED_ORIGIN را بررسی کنید؛ به README/NAVODILA مراجعه کنید.",
  "human.verificationFailedRetry": "تأیید ناموفق بود، دوباره تلاش کنید.",

  "provider.stripe": "💳 کارت (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "کشور انتخاب‌شده",
  "panel.currentlyRanked": "در حال حاضر در رتبه #{rank}",
  "panel.shareCopied": "کپی شد ✓",
  "panel.shareShared": "به اشتراک گذاشته شد ✓",
  "panel.shareButton": "🔗 اشتراک‌گذاری",

  "panel.tableClicks": "کلیک‌ها",
  "panel.tableFree": "رایگان",
  "panel.tablePaid": "پرداختی",
  "panel.rowAllTime": "کل زمان",
  "panel.rowThisYear": "امسال",
  "panel.rowThisWeek": "این هفته",
  "panel.rowToday": "امروز",

  "panel.totalCombined": "مجموع کل:",
  "panel.totalSupport": "مجموع حمایت‌ها:",

  "panel.paymentMethod": "روش پرداخت",
  "panel.noPaymentMethod": "در حال حاضر هیچ روش پرداختی در دسترس نیست.",
  "panel.supportAmount": "مبلغ حمایت (یورو)",
  "panel.amountRange": "مبلغ باید بین {min} و {max} باشد.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "کلیک‌های پرداختی تخمینی:",
  "panel.ratioInfo":
    "نسبت: {a} = {b} کلیک (برای مثال {c} = {d} کلیک). این فقط یک تخمین پیش از پرداخت است - تعداد نهایی کلیک‌ها همیشه توسط سرور و بر اساس پرداخت واقعاً تأییدشده محاسبه و تأیید می‌شود.",
  "panel.preparing": "در حال آماده‌سازی …",
  "panel.continueWith": "ادامه با {provider}",
  "panel.choosePaymentMethod": "یک روش پرداخت انتخاب کنید",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME تنظیم نشده است - برای پیکربندی به README مراجعه کنید.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID تنظیم نشده است - برای پیکربندی به README مراجعه کنید.",

  "panel.paypalAmountInfo": "مبلغ: {amount} (حدود {clicks} کلیک تخمینی). پرداخت را با دکمه PayPal در پایین تکمیل کنید.",
  "panel.back": "← بازگشت",

  "panel.bmcWarningTitle": "⚠️ پیش از ادامه به BuyMeCoffee:",
  "panel.bmcWarningBody":
    "کد زیر را در قسمت پیام/یادداشت هنگام پرداخت جای‌گذاری کنید — این تنها راهی است که ما می‌فهمیم از کدام کشور حمایت می‌کنید. بدون این کد، نمی‌توانیم پرداخت را به هیچ کشوری نسبت دهیم.",
  "panel.copy": "کپی",
  "panel.copied": "کپی شد ✓",
  "panel.suggestedAmount": "مبلغ پیشنهادی:",
  "panel.bmcAmountNote":
    "(حدود {clicks} کلیک تخمینی). متأسفانه BuyMeCoffee امکان انتقال مبلغ از طریق لینک را پشتیبانی نمی‌کند — آن را خودتان در سایت آن‌ها وارد/انتخاب کنید. تعداد واقعی کلیک‌ها همیشه بر اساس مبلغی که واقعاً از طریق BuyMeCoffee ارسال می‌کنید محاسبه می‌شود، نه بر اساس این تخمین.",
  "panel.openBmc": "باز کردن BuyMeCoffee و ادامه →",
  "panel.waitingProvider": "در انتظار تأیید پرداخت از سوی ارائه‌دهنده پرداخت …",
  "panel.waitingConfirmation": "در انتظار تأیید پرداخت …",
  "panel.timedOut":
    "زمان بررسی به پایان رسید. اگر پرداخت را کامل کرده‌اید، به‌محض دریافت تأییدیه توسط سرور، نقشه به‌روزرسانی می‌شود - گاهی این کار ممکن است کمی بیشتر طول بکشد.",
  "panel.checkAgain": "بررسی مجدد",

  "panel.cancelled": "پرداخت لغو شد یا انجام نشد. نقشه تغییری نکرده است.",
  "panel.tryAgain": "تلاش مجدد",

  "panel.confirmed": "✅ حمایت تأیید شد!",
  "panel.confirmedBody": "{country} به ازای {amount}، {clicks} کلیک پرداختی دریافت کرد.",

  "panel.errorPreparingSupport": "خطا در آماده‌سازی حمایت شما.",
  "panel.errorPreparingPayment": "خطا در آماده‌سازی پرداخت.",
  "panel.errorConfirmingPayment": "خطا در تأیید پرداخت.",
  "panel.errorPayingPaypal": "خطا در پرداخت از طریق PayPal.",

  "share.unranked": "{flag}{country} به حمایت شما در نقشه جهان نیاز دارد!\nبه آن کمک کنید در جدول امتیازات بالا برود 👇",
  "share.rank1": "{flag}{country} در حال حاضر رتبه ۱ است!\nبه ما کمک کنید در صدر بمانیم 👇",
  "share.rankN": "{flag}{country} در حال حاضر در رتبه #{rank} است!\nبه ما کمک کنید به رتبه ۱ برسیم 👇",

  "language.switcherLabel": "زبان",
};

export default fa;
